<template>
    <div class="box">
        <p class="title">业务已受理</p>
        <p class="subtitle">订单结果请留意扣费信息及通知</p>
        <img src="@/assets/images/ticket-success.png" class="success">
    </div>
    <a href="javascript:;" class="back" @click="jump">返回</a>
</template>

<script src="./Page.js"></script>

<style src="./Page.scss" lang="scss" scoped></style>